import React from "react";

/* =========================================================
   EmptyState
   Generic "nothing here" screen used by DataTable-driven pages
   (achievements, logs, targets, global explorer) whenever a
   filtered/unfiltered query returns zero rows.
========================================================= */
function EmptyState({ icon = "📭", title = "No data found", subtitle, action }) {
  return (
    <div className="empty-state-common">
      <div className="empty-state-icon">{icon}</div>
      <h4>{title}</h4>
      {subtitle && <p>{subtitle}</p>}
      {action && <div className="empty-state-action">{action}</div>}
    </div>
  );
}

export default EmptyState;
